"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";
import { ModalHeader } from "@/shared/ui/organisms";
interface ModalProps {
  open: boolean;
  children: ReactNode;
  title?: string;
  titlePosition?: "center" | "left" | "right";
  headerPaddingTopClassName?: string;
  headerMarginBottomClassName?: string;
  height?: string;
  round?: string;
  onClose: () => void;
}
const Modal = t0 => {
  const $ = _c(25);
  const {
    open,
    children,
    title,
    titlePosition: t1,
    headerPaddingTopClassName,
    headerMarginBottomClassName,
    height,
    round: t2,
    onClose
  } = t0;
  const titlePosition = t1 === undefined ? "left" : t1;
  const round = t2 === undefined ? "8px" : t2;
  const isFullScreen = height === "screen";
  let t3;
  let t4;
  if ($[0] !== open) {
    t3 = () => {
      if (open) {
        document.body.style.overflow = "hidden";
      }
      return _temp;
    };
    t4 = [open];
    $[0] = open;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  if (!open || typeof document === "undefined") {
    return null;
  }
  const resolvedHeaderPaddingTop = headerPaddingTopClassName ?? (isFullScreen ? "pt-[max(1rem,env(safe-area-inset-top,0px))]" : undefined);
  let t5;
  if ($[3] !== height || $[4] !== isFullScreen || $[5] !== round) {
    t5 = isFullScreen ? undefined : {
      height,
      borderRadius: `${round} ${round} 0 0`
    };
    $[3] = height;
    $[4] = isFullScreen;
    $[5] = round;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const panelStyle = t5;
  const panelClassName = isFullScreen ? "absolute inset-0 z-[101] flex w-full flex-col bg-white" : "absolute bottom-0 z-[101] flex w-full flex-col bg-white";
  let t6;
  if ($[7] !== onClose) {
    t6 = <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden={true} />;
    $[7] = onClose;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== headerMarginBottomClassName || $[10] !== onClose || $[11] !== resolvedHeaderPaddingTop || $[12] !== title || $[13] !== titlePosition) {
    t7 = <ModalHeader title={title} titlePosition={titlePosition} paddingTopClassName={resolvedHeaderPaddingTop} marginBottomClassName={headerMarginBottomClassName} onClose={onClose} />;
    $[9] = headerMarginBottomClassName;
    $[10] = onClose;
    $[11] = resolvedHeaderPaddingTop;
    $[12] = title;
    $[13] = titlePosition;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children) {
    t8 = <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{children}</div>;
    $[15] = children;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== panelClassName || $[18] !== panelStyle || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className={panelClassName} style={panelStyle}>{t7}{t8}</div>;
    $[17] = panelClassName;
    $[18] = panelStyle;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t6 || $[23] !== t9) {
    t10 = createPortal(<div className="fixed inset-0 z-[101] mx-auto max-w-[600px]">{t6}{t9}</div>, document.body);
    $[22] = t6;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default Modal;
function _temp() {
  document.body.style.overflow = "auto";
}